import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getGalleryDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  gallery: [
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_gallery_title_ms",
        className: "col-span-6",
        type: "text",
        name: "field_gallery_title_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
        // validation: { required: "Title (MS) is required" },
    },
    {
        fieldName: "Title (ZH)",
        fieldValue: "field_gallery_title_zh",
        className: "col-span-6",
        type: "text",
        name: "field_gallery_title_zh",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
        // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Source Image",
      fieldValue: "field_src_url",
      className: "col-span-6",
      type: "image",
      name: "field_src_url",
      formType: "file",
      label: "Source Image",
      usedFileType: 'image/*',
      placeholder: "Enter Source Image",
      validation: { required: "Source Image is required" },
    },
    // {
    //   fieldName: "Source Type",
    //   fieldValue: "field_src_type",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_src_type",
    //   formType: "input",
    //   label: "Source Type",
    //   placeholder: "Enter Source Type",
    //   validation: { required: "Source Type is required" },
    // },
    {
      fieldName: "Published",
      fieldValue: "field_gallery_published",
      className: "col-span-12",
      type: "checkbox",
      name: "field_gallery_published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Published is required" },
    },
  ]
};
